import React from 'react';
import { Box, Text, Button, Separator, SeparatorType, theme } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { ReactComponent as RouteNotFound } from '@bechtel/client-assets/dist/images/route-not-found.svg';
import { ReactComponent as PfLogo } from '@bechtel/client-assets/dist/images/pf-unauthorized-logo.svg';
import { ReactComponent as AsLogo } from '@bechtel/client-assets/dist/images/as-unauthorized-logo.svg';
import { useEnvProvider } from '~/hooks';
import { useNavigate } from 'react-router-dom';

export const NotFound = () => {
  const { envConfig }: { envConfig: Record<string, string> } = useEnvProvider();
  const navigate = useNavigate();

  return (
    <Box
      flexDirection={{ sm: 'column' }}
      alignItems={{ sm: 'center' }}
      justifyContent={{ sm: 'center' }}
      css={{ height: '100%', backgroundColor: theme.colors.white, width: '100%' }}
    >
      <Text size="700" weight="600" family="graphik" color="blue.700">
        <Trans>Not Found</Trans>
      </Text>
      <RouteNotFound style={{ height: '289px', width: '268px' }} />
      <Box mt={{ sm: '600' }}>
        <Text size="500">
          <Trans>The page you are trying to access is not found.</Trans>
        </Text>
      </Box>
      <Box mt={{ sm: '600' }}>
        <Button onClick={() => navigate('/')} css={{ padding: theme.spacings['500'] }}>
          <Trans>Go Back</Trans>
        </Button>
      </Box>
      <Separator
        type={SeparatorType.HORIZONTAL}
        spacing={'900'}
        borderWidth="1px"
        size="50%"
        style={{ backgroundColor: theme.colors.grey[300] as string }}
      />
      {envConfig.appName === 'PF' ? (
        <PfLogo
          style={{
            width: '179px',
            height: '33px',
          }}
        />
      ) : (
        <AsLogo
          style={{
            width: '179px',
            height: '33px',
          }}
        />
      )}
    </Box>
  );
};
